import React from 'react';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import { MdOutlineArticle } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

const ReportsNavbar = ({ tabActive, setTabActive }) => {
    const [t] = useTranslation('global');

    const tabs = [
        {
            id: 'SalesReport',
            label: t('reports.sales_Report'),
            icon: <HiOutlineDocumentReport size={28} />,
        },
        {
            id: 'requisition_report',
            label: t('reports.requisition_Report'),
            icon: <MdOutlineArticle size={28} />,
        },
    ];

    return (
        <div className='grid grid-cols-1 gap-3 border-b border-slate-200 pb-4 md:grid-cols-2'>
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    type='button'
                    onClick={() => setTabActive(tab.id)}
                    className={`flex flex-col items-center justify-center gap-2 rounded-2xl border p-4 text-slate-500 transition-all hover:bg-indigo-50 hover:text-indigo-800 ${
                        tabActive === tab.id
                            ? 'border-indigo-200 bg-indigo-100 text-indigo-800 shadow-sm'
                            : 'border-slate-200 bg-white'
                    }`}
                >
                    {tab.icon}
                    <span className='text-sm font-medium'>{tab.label}</span>
                </button>
            ))}
        </div>
    );
};

export default ReportsNavbar;
